import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { fetchAuthorization } from "./thunk";
import { AuthInitState } from "./types";

export const extraReducers = ( 
  builder: ActionReducerMapBuilder<AuthInitState>
) => {
  builder
    .addCase(fetchAuthorization.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchAuthorization.rejected, (state, action) => {
      state.loading = false;
      state.error = String(action.payload);
      state.authorization = false;
    })
    .addCase(fetchAuthorization.fulfilled, (state, action) => {
      state.authorization = true;
      state.user = action.payload
      
      state.loading = false;
      state.error = null;
    });
 
};
